<template>
  <div v-if="loadData">
    <v-toolbar
      color="black"
      class="white--text my-2"
      style="border-radius: 15px"
    >
      <v-btn flat icon class="white--text" @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-card-text
        class="text-md-center text-xs-center"
        :style="{
          fontSize:
            $vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '20px' : '28px',
        }"
      >
        {{ businessDetail.company_provider_wesmart_name }}
      </v-card-text>
    </v-toolbar>
    <v-card style="border-radius: 15px" class="pa-3">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm9>
            <div>
              <h3>ประเภทธุรกิจ</h3>
              <p>
                {{
                  businessDetail.company_provider_wesmart_type == "1"
                    ? "บุคคลธรรมดา"
                    : businessDetail.company_provider_wesmart_type == "2"
                    ? "นิติบุคคล"
                    : null
                }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm2>
            <div class="text-md-right d-flex">
              <v-card-actions
                :class="[
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                    ? 'justify-space-between'
                    : null,
                ]"
              >
                <h3 style="align-self: end; font-size: 18px">สถานะ</h3>
                <div
                  :class="[
                    businessDetail.company_provider_wesmart_status == 1
                      ? 'status_padding'
                      : businessDetail.company_provider_wesmart_status == 2
                      ? 'status_approve'
                      : businessDetail.company_provider_wesmart_status == 3
                      ? 'status_reject'
                      : businessDetail.company_provider_wesmart_status == 4
                      ? 'status_delete'
                      : businessDetail.company_provider_wesmart_status == 5
                      ? 'status_edit'
                      : null,
                  ]"
                >
                  {{
                    businessDetail.company_provider_wesmart_status == 1
                      ? "รอการตรวจสอบ"
                      : businessDetail.company_provider_wesmart_status == 2
                      ? "อนุมัติ"
                      : businessDetail.company_provider_wesmart_status == 3
                      ? "ปฎิเสธ"
                      : businessDetail.company_provider_wesmart_status == 4
                      ? "ลบ"
                      : businessDetail.company_provider_wesmart_status == 5
                      ? "แก้ไข"
                      : null
                  }}
                </div>
              </v-card-actions>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <div>
              <h3>หมายเลขบัตรประชาชนกรรมการผู้มีอำนาจลงนาม</h3>
              <p>
                {{ businessDetail.company_provider_wesmart_customer_id_card }}
              </p>
            </div>
            <div>
              <h3>เบอร์โทรธุรกิจ</h3>
              <p>{{ businessDetail.company_provider_wesmart_tel }}</p>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <div>
              <h3>อีเมล ธุรกิจ</h3>
              <p>
                {{ businessDetail.company_provider_wesmart_email }}
              </p>
            </div>
            <div>
              <h3>หมายเลขบุ๊คแบงค์ธุรกิจ</h3>
              <p>
                {{ businessDetail.company_provider_wesmart_bank_number }}
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <div>
              <h3>ที่อยู่ธุรกิจ</h3>
              <p>{{ businessDetail.company_provider_wesmart_address }}</p>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm3>
            <h3>จังหวัด</h3>
            <p>
              {{
                businessDetail.company_provider_wesmart_provider
                  .province_name_th
              }}
            </p>
          </v-flex>
          <v-flex xs12 sm3
            ><h3>อำเภอ</h3>
            <p>
              {{
                businessDetail.company_provider_wesmart_district
                  .district_name_th
              }}
            </p>
          </v-flex>
          <v-flex xs12 sm3>
            <h3>ตำบล</h3>
            <p>
              {{
                businessDetail.company_provider_wesmart_sub_district
                  .sub_district_name_th
              }}
            </p>
          </v-flex>
          <v-flex xs12 sm3>
            <h3>รหัสไปรษณีย์</h3>
            <p>
              {{ businessDetail.company_provider_wesmart_zipcode.zipcode_code }}
            </p>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-container
        v-if="businessDetail.company_provider_wesmart_image.length > 0"
      >
        <div class="my-3">
          <h3>เอกสารธุรกิจ</h3>
        </div>
        <v-layout row wrap>
          <v-flex
            xs12
            sm3
            v-for="(
              item, index
            ) in businessDetail.company_provider_wesmart_image"
            :key="index"
          >
            <v-card
              class="pa-4 mr-2"
              color="#F2F2F2"
              style="border-radius: 5px; width: 90%"
              :href="item"
              target="_blank"
            >
              <div style="display: flex; justify-content: center">
                <img
                  src="@/assets/back-office/PDF_icon.png"
                  style="width: 150px"
                />
              </div>
              <v-card-title>
                <div>
                  <h3 class="mb-0">
                    {{
                      index == 0
                        ? "สำเนาบัตรประชาชนกรรมการผู้มีอำนาจลงนาม"
                        : index == 1
                        ? "บัญชีบุ๊คแบงค์"
                        : index == 2
                        ? "อื่นๆ"
                        : null
                    }}
                  </h3>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-container v-if="businessDetail.company_secret_key.length > 0">
        <div class="my-3">
          <h3>Key for use API</h3>
        </div>
        <ul>
          <li
            v-for="(key, index) in businessDetail.company_secret_key"
            :key="index"
          >
            {{ key.client_provider_secret_key }}
          </li>
        </ul>
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-container>
        <v-layout row wrap justify-end v-if="false">
          <v-flex xs6 sm1>
            <v-card-actions>
              <v-btn
                color="green"
                class="pa-3 ml-2 white--text"
                large
                block
                @click="dialogApprove = true"
                >APPROVE</v-btn
              >
            </v-card-actions>
          </v-flex>
          <v-flex xs6 sm1>
            <v-card-actions>
              <v-btn
                block
                color="red"
                class="pa-3 ml-2 white--text"
                large
                @click="dialog = true"
                >REJECT</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          justify-start
          v-if="
            businessDetail.company_provider_wemsart_remark ||
            businessDetail.company_provider_wesmart_status == 3
          "
        >
          <v-flex xs3>
            <h3>ถูกปฎิเสธเพราะ</h3>
            <p class="ma-3">
              {{ businessDetail.company_provider_wemsart_remark }}
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card style="border-radius: 15px" class="pa-2">
        <v-toolbar flat height="40" color="white">
          <v-spacer></v-spacer>
          <v-btn flat icon color="black" @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-md-center" style="font-size: 25px">
          คุณต้องการปฎิเสธธุรกิจนี้ใช่ไหม
        </v-card-text>
        <v-container fluid grid-list-md>
          <v-form ref="form">
            <v-textarea
              :rules="[rules.required]"
              box
              v-model="textArea"
              label="กรอกเหตุผลที่ปฎิเสธ"
            ></v-textarea>
          </v-form>
        </v-container>
        <v-card-actions class="justify-center">
          <v-btn
            @click="reject(businessDetail)"
            color="red"
            class="pa-3 ml-2 white--text"
            large
            >REJECT</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogApprove" persistent max-width="450">
      <v-card style="border-radius: 15px" class="pa-2">
        <v-card-text class="text-md-center" style="font-size: 25px">
          คุณต้องการอนุมัติธุรกิจนี้ใช่ไหม
        </v-card-text>
        <v-card-actions class="justify-center my-4">
          <v-btn
            style="width: 35%"
            @click="approve(businessDetail)"
            color="#00DE00"
            class="pa-3 white--text"
            large
            >CONFIRM</v-btn
          >
          <v-btn
            style="width: 35%"
            @click="close()"
            color="#FF0000"
            class="pa-3 ml-3 white--text"
            large
            >CANCEL</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import businesslist from "@/components/back-office/Business/Business-table.vue";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      textArea: "",
      rules: {
        required: (value) => value == "0" || !!value || "Required.",
      },
      dialogApprove: false,
      loadData: false,
    };
  },
  computed: {
    ...mapState({
      businessDetail: (state) => state.Business.businessDetail,
    }),
  },
  methods: {
    ...mapActions({
      fetchBusinesslistDetail: "Business/fetchBusinesslistDetail",
      ApproveRejectBusiness: "Business/ApproveRejectBusiness",
    }),
    async approve(item) {
      if (item) {
        let payload = {
          business_id: item.company_provider_wesmart_id,
          status: 2,
          remark: null,
        };
        let res = await this.ApproveRejectBusiness(payload);
        if (res == false) return;
        this.dialogApprove = false;
        this.$router.push({
          name: "businesstable",
        });
      }
    },
    async reject(item) {
      if (this.$refs.form.validate()) {
        let payload = {
          business_id: item.company_provider_wesmart_id,
          status: 3,
          remark: this.textArea,
        };
        let res = await this.ApproveRejectBusiness(payload);
        if (res == false) return;
        this.$refs.form.resetValidation();
        this.$refs.form.reset();
        this.dialog = false;
        this.$router.push({
          name: "businesstable",
        });
      }
    },
    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog = false;
      this.dialogApprove = false;
    },
    goBack() {
      this.$router.go(-1);
    },
    async getData() {
      this.loadingMessage = true;
      let res = await this.fetchBusinesslistDetail(
        this.$route.params.business_id
      );
      if (res == false) return;
      this.loadData = true;
      this.loadingMessage = false;
    },
  },

  created() {
    this.getData();
  },
};
</script>
<style scoped>
.status_padding {
  background: #fddf00 0% 0% no-repeat padding-box;
  font-size: 18px;
  width: 140px;
  text-align: center;
  border-radius: 5px;
  margin-left: 5px;
  font-weight: 500;
  padding: 2px;
  font-weight: 500;
}
.status_reject {
  background: #ff0000 0% 0% no-repeat padding-box;
  font-weight: bolder;
  font-size: 19px;
  border-radius: 5px;
  width: 110px;
  margin-left: 5px;
  text-align: center;
  color: white;
}
.status_approve {
  background: #00de00 0% 0% no-repeat padding-box;
  font-size: 18px;
  width: 110px;
  text-align: center;
  border-radius: 5px;
  margin-left: 5px;
  font-weight: 500;
  color: white;
}
.status_delete {
  background: black 0% 0% no-repeat padding-box;
  font-size: 18px;
  width: 110px;
  text-align: center;
  border-radius: 5px;
  margin-left: 5px;
  font-weight: 500;
  color: white;
}
.status_edit {
  background: #00baff;
  font-size: 18px;
  width: 110px;
  text-align: center;
  border-radius: 5px;
  margin-left: 5px;
  font-weight: 500;
}
h3 {
  font-weight: bolder;
  font-size: 19px;
}
p {
  font-weight: 550;
  font-size: 16px;
  margin-left: 10px;
}
</style>
